import { useState } from 'react';
import type { Timeframe } from '@contracts/market';
import { CandleChart, TimeframeSelector } from '../components/CandleChart';
import { FeedBanner } from '../components/FeedBanner';
import { LatencyPanel } from '../components/LatencyPanel';
import { NewsTimeline } from '../components/NewsTimeline';
import { Panel } from '../components/Panel';
import { PriceAlertsPanel } from '../components/PriceAlertsPanel';
import { PriceHeader } from '../components/PriceHeader';
import { SignalPanel } from '../components/SignalPanel';
import { SRPanel } from '../components/SRPanel';
import { SystemHealthPanel } from '../components/SystemPanels';
import { useFeedView } from '../hooks/useFeedView';

export function DashboardPage() {
  const view = useFeedView();
  const [timeframe, setTimeframe] = useState<Timeframe>('5m');

  return (
    <>
      <FeedBanner view={view} />
      <PriceHeader view={view} />
      <div style={{ marginTop: 16 }}>
        <PriceAlertsPanel />
      </div>
      <div style={{ marginTop: 16 }}>
        <Panel title="XAUUSD price chart" meta={<TimeframeSelector value={timeframe} onChange={setTimeframe} />}>
          <CandleChart timeframe={timeframe} />
        </Panel>
      </div>
      <div style={{ marginTop: 16 }}>
        <SignalPanel />
      </div>
      <div style={{ marginTop: 16 }}>
        <SRPanel />
      </div>
      <div className="grid grid--2" style={{ marginTop: 16 }}>
        <NewsTimeline />
        <div className="stack">
          <LatencyPanel compact />
          <SystemHealthPanel />
        </div>
      </div>
    </>
  );
}
